/* @flow */

import { Case } from '../Case';
import { numericalCompare, prettyOperator, inverseOperator } from '../../../utils';

const options = ['characters', 'words'];

export class CommentLength extends Case {
	static text = 'Comment length';

	static parseCriterion(input: *) { return { op: '>=', kind: 'words', val: parseInt(input, 10) }; }

	static fields = ['comment length is ', { type: 'select', options: 'COMPARISON', id: 'op' }, ' ', { type: 'number', id: 'val' }, ' ', { type: 'select', id: 'kind', options }];
	static defaultConditions = { op: '>', kind: 'words', val: 0 };

	static pattern = 'integer';

	trueText = `length ${prettyOperator(this.value.op)} ${this.value.val} ${this.value.kind}`;
	falseText = `length ${prettyOperator(inverseOperator(this.value.op))} ${this.value.val} ${this.value.kind}`;

	validator() { return Number.isInteger(this.value.val); }

	evaluate(thing: *) {
		const md = thing.entry.querySelector('.md');
		if (!md) return false;
		switch (this.value.kind) {
			case 'characters': return numericalCompare(this.value.op, md.textContent.length, this.value.val);
			case 'words': return numericalCompare(this.value.op, md.textContent.split(' ').length, this.value.val);
			default: return false;
		}
	}
}



// WEBPACK FOOTER //
// ./lib/modules/filteReddit/commentCases/CommentLength.js